import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import "./Discounts.css";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import RegisterTextbox from "../../components/RegisterTextBox";
import { Form, Spinner } from "react-bootstrap";
import CustomButton from "../../components/CustomButton";
import RegisterSelect from "../../components/RegisterSelect";
import RegisterRadio from "../../components/Radio";
import API from "../../api/axiosConfig";
import { useNavigate, useParams } from "react-router";

function Discounts() {
  const [selectedValue, setSelectedValue] = useState("");
  const [type, setType] = useState(0);
  const [reason, setReason] = useState("");
  const [amountType, setAmountType] = useState(0);
  const [amount, setAmount] = useState(0);
  const [date, setDate] = useState(new Date().toISOString().substr(0, 10));
  const navigate = useNavigate("/");
  const [error, setError] = useState([]);
  const { id } = useParams();
  const [showAward, setShowAward] = useState(false);
  const [showDeduction, setShowDeduction] = useState(false);
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [account, setAccount] = useState([]);
  const [accounttree, setAccounttree] = useState("");

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    setAmountType(e.target.value);
  };

  const getAccount = async () => {
    try {
      const res = await API.get("transactions/components/donations");
      const data = await res;
      if (data.status === 200) {
        setAccount(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAccount();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const mForm = new FormData();
    mForm.append("type", type);
    mForm.append("reason", reason);
    mForm.append("amounttype", amountType);
    mForm.append("amount", amount);
    mForm.append("date", date);
    mForm.append("description", description);
    mForm.append("id", id);
    mForm.append("component", accounttree);
    try {
      const res = await API.post("/salaryactions/store", mForm);
      const data = await res;
      if (data.status === 200) {
        navigate("/hrreport/discounts");
      }
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
      setError(error.response.data.errors);
    }
  };

const handleTypeChange = (e) => {
  const value = e.target.value;
  setType(value);

  if (value === "0") {
    setShowAward(true);
    setShowDeduction(false);
  } else {
    setShowAward(false);
    setShowDeduction(true);
  }
};
  useEffect(() => {
    const editType = setTimeout(() => {
      setType("0")
      setShowAward(true);
      setShowDeduction(false);
    }, 500);
      return () => {
          clearTimeout(editType)
      }
  }, []);
  return (
    <>
      <div className="investigations">
        <Title
          title="إضافة خصم او مكافآة"
          icon={<FontAwesomeIcon icon={faPlusCircle} />}
        />

        <Form className="investigationsContainer" onSubmit={handleSubmit}>
          <div className="radioContainer radioContainer3">
            <h5>النوع</h5>
            <div
              className="clientRadios clientRadios3"
              onChange={handleTypeChange}
              value={type}
            >
              <RegisterRadio
                name="type"

  label="مكافآة"
  value="0"
  checked={type === "0"}
  onChange={handleTypeChange}
/>

              <RegisterRadio
                name="type"

  label="خصم"
  value="1"
  checked={type === "1"}
  onChange={handleTypeChange}
/>

            </div>
          </div>
          {showAward && (
            <RegisterSelect
              id="drop"
              label="السبب"
              stylee={{ width: "45% !important" }}
              parentStyle={{ width: "35%", marginBottom: "20px" }}
              options={[
                { value: "0", label: "إختر المكافأة" },
                { value: "41101002", label: "بدل السكن" },
                { value: "41101003", label: "بدل المواصلات" },
                { value: "41101004", label: "بدل اتصال" },
                { value: "41101005", label: "بدل اعاشة" },
                { value: "41101006", label: "بدل طبيعة عمل" },
                { value: "41101007", label: "العمل الإضافي" },
                { value: "41102001", label: "الإجازات" },
                { value: "41102002", label: "تذاكر السفر" },
                { value: "41102005", label: "مكافات وحوافز موسمية" },
                { value: "41102006", label: "مكافات وحوافز سنوية" },
                { value: "41102008", label: "مصاريف الطعام" },
                { value: "41102009", label: "بدل اثاث" },
                { value: "41102010", label: "مصاريف حكومية - تجديد إقامات" },
                { value: "41102011", label: "مصاريف حكومية - تأشيرات" },
                { value: "41102012", label: "مصاريف حكومية - نقل كفالات" },
                { value: "41102013", label: "مصاريف حكومية - رسوم" },
                { value: "41102014", label: "رسوم المدارس" },
                { value: "41102015", label: "ملابس العمال الموحد" },
                { value: "41102019", label: "بدل الانتداب" },
                { value: "41102020", label: "تعويضات نهاية الخدمة" },
                { value: "42301002", label: "مصاريف التشغيل مزايا.وحوافز" },
                { value: "44102", label: "مصاريف جمع الاموال مزايا وحوافز." },
              ]}
              onChange={(e) => setReason(e.target.value)}
              value={reason}
            />
          )}
          {showDeduction && (
            <RegisterSelect
              id="drop1"
              label="السبب"
              stylee={{ width: "45% !important" }}
              parentStyle={{ width: "35%", marginBottom: "20px" }}
              options={[
                { value: "0", label: "إختر الخصم" },
                { value: "41101009", label: "خصومات الرواتب" },
                { value: "42301006", label: "خصومات مصاريف التشغيل" },
                { value: "44106", label: "خصومات مصاريف جمع الاموال" },
              ]}
              onChange={(e) => setReason(e.target.value)}
              value={reason}
            />
          )}{" "}
          {error && <p style={{ color: "red" }}>{error.reason}</p>}
          <RegisterTextbox
            parentStyle={{ width: "35%" }}
            id="reason"
            label="الوصف"
            type="text"
            stylee={{ width: "45%" }}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
          {error && <p style={{ color: "red" }}>{error.description}</p>}
          {/* <RegisterTextbox
                        parentStyle={{ width: "35%" }}
                        id="date"
                        label='التاريخ'
                        type="date"
                        stylee={{ width: "45%" }}
                        onChange={handleDateReason}
                    /> */}
          <p
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
              width: "35%",
              marginBottom: "10px",
            }}
          >
            اليوم
          </p>
          <input
            type="date"
            id="date"
            onChange={(e) => setDate(e.target.value)}
            value={date}
            className="custom-datepicker"
            style={{ width: "35%" }}
          />
          {error && <p style={{ color: "red" }}>{error.date}</p>}
          <RegisterSelect
            id="value"
            label="القيمة"
            stylee={{ width: "45% !important" }}
            parentStyle={{ width: "35%", marginBottom: "20px" }}
            options={[
              { value: "default", label: "إختر الحالة" },
              { value: "0", label: "الأيام" },
              { value: "1", label: "المال" },
            ]}
            onChange={handleSelectChange}
            value={amountType ? amountType : "default"}
          />
          {selectedValue == "0" && (
            <RegisterTextbox
              parentStyle={{ width: "35%" }}
              id="days"
              label="عدد الأيام"
              type="number"
              stylee={{ width: "45%" }}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          )}
          {selectedValue == "1" && (
            <RegisterTextbox
              parentStyle={{ width: "35%" }}
              id="money"
              label="قيمة المال"
              type="number"
              stylee={{ width: "45%" }}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          )}
          {error && <p style={{ color: "red" }}>{error.amount}</p>}
          {showAward && (
            <RegisterSelect
              id="value"
              label="حساب ترحيل الراتب"
              stylee={{ width: "45% !important" }}
              parentStyle={{ width: "35%", marginBottom: "20px" }}
              options={[
                { value: "0", label: "إختر حساب الترحيل" },
                ...account.map((account) => ({
                  value: account.id,
                  label: account.name,
                })),
              ]}
              onChange={(e) => setAccounttree(e.target.value)}
              value={accounttree}
            />
          )}
          {showDeduction && (
            <RegisterSelect
              id="value"
              label="حساب الترحيل"
              stylee={{ width: "45% !important" }}
              parentStyle={{ width: "35%", marginBottom: "20px" }}
              options={[
                { value: "0", label: "إختر حساب الترحيل" },
                {
                  value: "9e5000f6-d504-42c0-8562-a010a116bf50",
                  label: "الرواتب والأجور النقدية",
                },
                {
                  value: "9e50010a-9984-4062-b3ab-9facd6849180",
                  label: "مصاريف التشغيل المحمله على النشاط",
                },
                {
                  value: "9e50010e-6ab8-4e88-b916-d593124ed685",
                  label: "مصاريف جمع الاموال",
                },
              ]}
              onChange={(e) => setAccounttree(e.target.value)}
              value={accounttree}
            />
          )}
          {error && <p style={{ color: "red" }}>{error.component}</p>}
          {isSubmitting ? (
            <Spinner
              animation="border"
              variant="primary"
              style={{ display: "block", margin: "auto" }}
            />
          ) : (
            <CustomButton text="حفظ" className="addClientBtn" />
          )}
        </Form>
      </div>
    </>
  );
}

export default Discounts;
